import $ from 'jquery';
import * as Website from '../Config/Website.js';

const init = () => {
$('.js-accordion').each(function() {
  const $trigger = $(this);
  const $content = $trigger.next();
  
  // 閉じるボタンがまだ存在しない場合のみ追加
  // if($content.find('.js-accordion-close').length === 0) {
  //   const $closeBtn = $('<button>', {
  //     class: 'js-accordion-close',
  //     text: '閉じる',
  //     css: {
  //       display: 'block',
  //       marginTop: '10px'
  //     }
  //   });
  //   $content.append($closeBtn);
  // }
  
  // 初期状態が開いている場合
  if($trigger.hasClass(Website.classList.actOpen)) {
    $content.show().addClass(Website.classList.actOpen);
  }
});

// トグル機能（元のトリガー）
$('.js-accordion').on('click', function() {
  const $trigger = $(this);
  const $content = $trigger.next();
  
  $trigger.toggleClass(Website.classList.actOpen);
  $content.toggleClass(Website.classList.actOpen).slideToggle();
});

// 閉じるボタンのクリックイベント
$(document).on('click', '.js-accordion-close', function() {
  const $closeBtn = $(this);
  const $content = $closeBtn.closest('.js-accordion').next().length > 0 
    ? $closeBtn.parent() 
    : $closeBtn.parent();
  const $trigger = $content.prev('.js-accordion');
  
  // トリガーとコンテンツの両方からactOpenクラスを削除
  $trigger.removeClass(Website.classList.actOpen);
  $content.removeClass(Website.classList.actOpen).slideUp();
});  $('.js-accordionSP').each(function() {
    if($(this).hasClass(Website.classList.actOpen) && Website.status.winWidth < Website.options.shiftpoint) {
      $(this).next().show().addClass(Website.classList.actOpen);
    }
  });

  // $(document).on('click', '.js-accordion', function() {
  //   $(this).toggleClass(Website.classList.actOpen);
  //   $(this).next().slideToggle(300).toggleClass(Website.classList.actOpen);
  // });

  $(document).on('click', '.js-accordionSP', function() {
    if( Website.status.winWidth < Website.options.shiftpoint ) {
      $(this).toggleClass(Website.classList.actOpen);
      $(this).next().slideToggle(300,).toggleClass(Website.classList.actOpen);
    }
  }); 

  document.addEventListener('click', (e) => {
    let target = null;
    if(e.target.closest('.js-accordionCSS')) {
      target = e.target.closest('.js-accordionCSS');
    } else if(e.target.matches('.js-accordionCSS')) {
      target = e.target;
    }
    if(target) {
      let targetElm = target.nextElementSibling;
      if(target.dataset.accordion) {
        targetElm = document.getElementById(target.dataset.accordion);
      }
      if(!targetElm) return;
      target.classList.toggle(Website.classList.actOpen);
      targetElm.classList.toggle(Website.classList.actOpen);
    } 
  });
}

const css = () => {
  const triggerElms = document.getElementsByClassName('js-accordionCSS');
  if(triggerElms.length === 0) return;
  for(const triggerElm of triggerElms) {
    let targetElm = triggerElm.nextElementSibling;
    if(triggerElm.dataset.accordion) {
      targetElm = document.getElementById(triggerElm.dataset.accordion);
    }
    if(!targetElm) return;
    const targetElmHeight = targetElm.scrollHeight;

    targetElm.style.setProperty('--h', targetElmHeight + 'px');
  }
}

export {
  init, 
  css
}